<template>
  <el-form
    ref="form"
    status-icon
    :model="form"
    :rules="rules"
    label-width="90px"
  >
    <el-form-item label="登录名" prop="username">
      <el-input v-model.trim="form.username" auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item label="显示名" prop="screen_name">
      <el-input v-model.trim="form.screen_name" auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item label="密码" prop="pass">
      <el-input
        type="password"
        v-model="form.pass"
        auto-complete="off"
      ></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="checkPass">
      <el-input
        type="password"
        v-model="form.checkPass"
        auto-complete="off"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button style="width: 100%" type="primary" @click="onSubmit"
        >注册</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { RoleCNMixin, UserFormMixin, OopsErrorELMessage } from "@/mixins";
import axios from "axios";
export default {
  name: "UserRegisterForm",
  props: ["inviteKey"],
  mixins: [RoleCNMixin, UserFormMixin, OopsErrorELMessage],
  data() {
    return {
      form: {
        username: "",
        screen_name: "",
        pass: "",
        checkPass: ""
      }
    };
  },
  computed: {
    username() {
      return this.form.username;
    }
  },
  watch: {
    username(v) {
      this.form.username = v.replace(/[^\a-\z\A-\Z0-9]/g, ""); // eslint-disable-line
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        let { username, screen_name, pass } = this.form;
        let req = {
          username,
          screen_name,
          password: pass,
          invite_key: this.inviteKey
        };
        axios
          .create()
          .post("/api/v1/users/invites/register", req)
          .then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "注册成功"
            });
            setTimeout(() => {
              this.$router.push({ name: "login" });
            }, 1000);
          })
          .catch(() => {
            this.oopsError("注册失败");
          });
      });
    }
  }
};
</script>

<style scoped></style>
